<template>
  <div class="tripetto-loading" role="status" aria-live="polite">
    <span class="tripetto-loading__spinner" aria-hidden="true"></span>
    <span class="tripetto-loading__text">{{ text }}</span>
  </div>
</template>

<script>
import { getTranslatedText } from '@/constants/constants';

export default {
  name: 'TripettoLoading',
  // Also used as the async-component placeholder for the form components, so it
  // is handed their props as attributes. Keep those out of the DOM.
  inheritAttrs: false,
  computed: {
    text() {
      return getTranslatedText('tripettoForm', this.$store.getters.SITE_LOCALE).loading;
    },
  },
};
</script>
